import { Modal } from "antd";
import useMediaQuery from "hook/useMediaQuery";
import { ModalClose } from "themes/Icon";
import "./modal_comp.scss";
function ModalComp({
  open,
  width = 600,
  footer,
  setOpen,
  OkClick = () => {},
  children,
  title,
  CancelClick = () => {},
}) {
  const handleOk = () => {
    setOpen(false);
    OkClick();
  };
  const handleCancel = () => {
    setOpen(false);
    CancelClick();
  };

  const isDesktop = useMediaQuery("(min-width: 700px)");

  return (
    <Modal
      centered={!isDesktop}
      width={width}
      className="modal-comp"
      footer={footer}
      closeIcon={<ModalClose />}
      title={title}
      open={open}
      onOk={handleOk}
      destroyOnClose={true}
      onCancel={handleCancel}
    >
      {children}
    </Modal>
  );
}

export default ModalComp;
